<script setup lang="ts">
import { ref } from "vue";

// defineOptions({
//   inheritAttrs: false,
// })

const props = withDefaults(defineProps<{ modelValue?: string; maxDate?: string }>(), {
    modelValue: "",
    maxDate: new Date().toISOString().split("T")[0],
});

const emit = defineEmits<{
    (e: "update:modelValue", value: string): void;
}>();

function onChange(event: Event) {
    const target = event.target as HTMLInputElement;
    emit("update:modelValue", target.value);
}

const inputRef = ref(null);

function openDatePicker() {
    inputRef.value?.showPicker?.();
}
</script>

<template>
    <div class="tiw__datepicker" @click="openDatePicker">
        <span class="tiw__datepicker__value">{{ props.modelValue }}</span>
        <input
            ref="inputRef"
            class="tiw__datepicker__input"
            type="date"
            :max="maxDate"
            :value="props.modelValue"
            v-bind="$attrs"
            @change="onChange"
        />
        <svg
            class="tiw__datepicker__icon"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17 1V3M5 1V3M10.996 12H11.004M10.996 16H11.004M14.991 12H15M7 12H7.009M7 16H7.009M2.5 7H19.5M2 7H20M1.5 11.243C1.5 6.886 1.5 4.707 2.752 3.353C4.004 2 6.02 2 10.05 2H11.95C15.98 2 17.996 2 19.248 3.354C20.5 4.707 20.5 6.886 20.5 11.244V11.757C20.5 16.114 20.5 18.293 19.248 19.647C17.996 21 15.98 21 11.95 21H10.05C6.02 21 4.004 21 2.752 19.646C1.5 18.293 1.5 16.114 1.5 11.756V11.243Z"
                stroke="#808D9A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </div>
</template>

<style lang="scss" src="./datePicker.scss"></style>
